/* Maison Voyageur — customisations front (chargé par footer section mv-custom) */
(function () {
  var s = document.createElement('style');
  s.textContent = '.product-form__submit,.product-form__submit::after{border:0!important;box-shadow:none!important;}shopify-chat{display:none!important;}.mv-gift-badge{position:absolute;top:10px;left:10px;z-index:3;background:#36154D;color:#FAF7F2;font-size:11px;line-height:1;padding:6px 9px;border-radius:6px;letter-spacing:.02em;pointer-events:none;font-weight:600;}';
  document.head.appendChild(s);

  var NOGIFT = /discover|descubrimiento|pack|bundle|voyage|15ml|set-de/i;

  function L() { return (document.documentElement.lang || 'es').slice(0, 2); }

  function relabelCheckout() {
    document.querySelectorAll('button[name="checkout"], .cart__checkout-button, #checkout').forEach(function (b) {
      var t = (b.textContent || '').trim();
      if (t === 'Passer à la caisse' || t === 'Étape suivante') b.textContent = 'Continuer';
    });
  }

  function updateAnnounce() {
    var el = document.querySelector('.mva-gift');
    if (!el) return;
    var l = L();
    var t = l === 'fr' ? '15ml offert avec chaque parfum 100ml'
          : l === 'en' ? '15ml gift with every 100ml perfume'
          : '15ml de regalo con cada perfume 100ml';
    if (el.textContent.trim() !== t) el.textContent = t;
  }

  function updateGiftBox() {
    var b = document.querySelector('.mvgift__b');
    if (!b) return;
    var l = L();
    var t = l === 'fr' ? '15 ml offert avec ton parfum' : l === 'en' ? '15 ml gift with your perfume' : '15 ml de regalo con tu perfume';
    if (b.textContent.trim() !== t) b.textContent = t;
  }

  function giftText(href, full) {
    return '🎁 15 ml de regalo';
  }

  function addCardBadges() {
    document.querySelectorAll('.mvic__card, .card-wrapper').forEach(function (card) {
      if (card.querySelector('.mv-gift-badge')) return;
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;
      if (NOGIFT.test(link.getAttribute('href') || '')) return;
      var media = card.querySelector('.mvic__imgw') || card.querySelector('.card__media') || card;
      if (!media) return;
      var badge = document.createElement('span');
      badge.className = 'mv-gift-badge';
      badge.textContent = giftText(link.getAttribute('href'), false);
      if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
      media.appendChild(badge);
    });
  }

  function addProductBadge() {
    if (!/\/products\//.test(location.pathname)) return;
    if (NOGIFT.test(location.pathname)) return;
    var media = document.querySelector('.product__media-wrapper');
    if (!media || media.querySelector('.mv-gift-badge')) return;
    var badge = document.createElement('span');
    badge.className = 'mv-gift-badge';
    badge.textContent = giftText(location.pathname, false);
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    media.appendChild(badge);
  }

  function autoplayProductVideos() {
    if (!/\/products\//.test(location.pathname)) return;
    document.querySelectorAll('.product__media-list deferred-media:not([data-mvauto])').forEach(function (dm) {
      dm.setAttribute('data-mvauto', '1');
      var btn = dm.querySelector('.deferred-media__poster-button, button');
      if (btn) btn.click();
    });
    document.querySelectorAll('.product__media-list video, .product__media video').forEach(function (v) {
      if (v.getAttribute('data-mvauto')) return;
      v.setAttribute('data-mvauto', '1');
      v.muted = true; v.defaultMuted = true; v.loop = true; v.autoplay = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('loop', '');
      var pr = v.play(); if (pr && pr.catch) pr.catch(function () {});
    });
  }

  function addWhatsApp() {
    if (document.getElementById('mv-wa')) return;
    var a = document.createElement('a');
    a.id = 'mv-wa';
    a.href = 'https://wa.me/33766314792';
    a.target = '_blank';
    a.rel = 'noopener';
    a.setAttribute('aria-label', 'WhatsApp');
    a.style.cssText = 'position:fixed;right:20px;bottom:20px;z-index:9999;width:56px;height:56px;border-radius:50%;background:#25D366;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 12px rgba(0,0,0,.25);text-decoration:none;';
    a.innerHTML = '<svg width="30" height="30" viewBox="0 0 32 32" fill="#fff" xmlns="http://www.w3.org/2000/svg"><path d="M16 3C9.4 3 4 8.4 4 15c0 2.1.6 4.1 1.6 5.9L4 29l8.3-1.6c1.7.9 3.7 1.4 5.7 1.4 6.6 0 12-5.4 12-12S22.6 3 16 3zm0 21.8c-1.8 0-3.5-.5-5-1.4l-.4-.2-4.9 1 1-4.8-.2-.4c-1-1.6-1.5-3.4-1.5-5.3C5.5 9.3 10.2 4.6 16 4.6S26.5 9.3 26.5 15 21.8 24.8 16 24.8zm5.7-7.3c-.3-.2-1.8-.9-2.1-1-.3-.1-.5-.2-.7.2-.2.3-.8 1-.9 1.2-.2.2-.3.2-.6.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.2-.2.2-.3.3-.5.1-.2.1-.4 0-.5-.1-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.5s1.1 2.9 1.2 3.1c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.8-.7 2-1.5.3-.7.3-1.4.2-1.5-.1-.1-.3-.2-.6-.3z"/></svg>';
    document.body.appendChild(a);
  }

  function run() {
    relabelCheckout();
    updateAnnounce();
    updateGiftBox();
    addCardBadges();
    addProductBadge();
    autoplayProductVideos();
  }

  function init() {
    run();
    addWhatsApp();
    if (document.body) new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();